<section id="studentPasswordModalContainer" class="modal-container">
  <header class="modal-header">
    <h1 class="modal-title" id="studentPasswordModalTitle">Create new passwords</h1>
  </header>
  <div class="modal-body" id="studentPasswordModalMessage">
    <p>
      You are about to create new passwords for all students in this school. All students will no longer be able to login with their previous passwords. You can download a spreadsheet of the new passwords only once.
    </p>
    <zbp-branded-fallback-download
      #exportDownload
      [displayIcon]="true"
      [downloadPrompt]="''"
      downloadLinkText="Download spreadsheet of new passwords"
      class="fallback-download-container">
    </zbp-branded-fallback-download>

  </div>
  <div class="modal-footer">
    <zbp-button-component
      label="Cancel"
      theme="ghost"
      [ariaLabel]="cancelAriaLabel"
      (clickHandler)="dismiss()"
      type="button">
    </zbp-button-component>
    <zbp-button-component
      #confirmButton
      id="confirmGenerateButton"
      [ariaLabel]="confirmAriaLabel"
      (clickHandler)="generateStudentPasswords()"
      label="Confirm"
      theme="primary"
      [disabled]="isRegeneratingPasswords"
      type="button">
    </zbp-button-component>
  </div>
</section>
